/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router-dom'
//constants

//css
import './AccountsHead.scss'
import {toAbsoluteUrl, KTSVG, camelCaseToNormalCase} from '../../../../_metronic/helpers'
import {fetchAsyncAdminDetails} from '../../../Redux/AdminPanel/AccountModuleSlice/AdminProfileSlice'
import {GeneralDataOFLoginUser} from '../../../Utils/Auth'
import {getAllUserDetails} from '../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {createFirstLetter} from '../../../Utils/_helpers'
import {FixedTwoDecimal} from '../../../Utils/_helpers/string'
import {useLazyGetCountMessageQuery} from '../../../../services/cellcast.v2'
import {Spinner} from 'react-bootstrap'

const AdminAccountHeader: React.FC = () => {
  const data = useSelector(getAllUserDetails)
  const location = useLocation()
  const dispatch = useDispatch()
  const user = useSelector((state: any) => state?.AdminAuth?.adminData?.data?.user?.role)
  const creditDu = useSelector((state: any) => state?.AdminAuth?.adminData?.data)
  const userData: any = useSelector((state: any) => state?.AdminAuth?.adminData?.data?.user)

  // const token: any = useSelector()

  const creditsData = useSelector((state: any) => state?.userDetails?.userDetails?.data)
  const [fetchCountMessage, {data: countMessage, isLoading: fetchCountMessageLoading}] =
    useLazyGetCountMessageQuery()

  // let data = {
  //   refreshToken: token.data?.refreshToken,
  //   accessToken: token?.data.accessToken,
  // }

  useEffect(() => {
    dispatch(fetchAsyncAdminDetails())
    // if (!userData) {
    //   dispatch(fetchAsyncRefreshToken(data))
    // }
  }, [])

  useEffect(() => {
    fetchCountMessage(null)
  }, [data])

  const SuperAdmin = ['Overview', 'Staff Account', 'Notifications', 'Approvals']
  const StaffAdmin = [
    'Overview',
    'Settings',
    'Staff Account',
    'Affiliate',
    'Commission',
    'Notifications',
    'Approvals',
  ]
  const User = [
    'Overview',
    'Settings',
    'Billing',
    'Dedicated Numbers',
    'Team List',
    'API Keys',
    'Business Name',
  ]
  const Navbar = user == 'superAdmin' ? SuperAdmin : StaffAdmin
  const listItems = Navbar.map((key: any, index: any) => (
    <li key={index?.toString()} className='nav-item'>
      <Link
        className={
          `nav-link text-active-primary me-6 ` +
          (location?.pathname === `/accounts/${key?.toLowerCase().replace(/ /g, '-')}` && 'active')
        }
        to={`/accounts/${key?.toLowerCase().replace(/ /g, '-')}`}
      >
        {key}
      </Link>
    </li>
  ))
  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0'>
        <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
          <div className='me-7 mb-4'>
            <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
              {data?.avatar == '' || data?.avatar == undefined || data?.avatar == 'undefined' ? (
                <span
                  className='squere1'
                  style={{
                    width: '160px',
                    height: '160px',
                  }}
                >{`${
                  data?.firstName !== undefined && data?.firstName !== ''
                    ? data?.firstName?.split('')?.[0]?.toUpperCase() ?? 'C'
                    : createFirstLetter(data?.name)?.firstName ?? 'C'
                }${
                  data?.lastName !== undefined && data?.lastName !== ''
                    ? data?.lastName?.split('')?.[0]?.toUpperCase() ?? 'C'
                    : createFirstLetter(data?.name).lastName ?? 'C'
                }`}</span>
              ) : (
                <img src={data?.avatar} alt='avatar' />
              )}
              <div
                className={`position-absolute translate-middle bottom-0 start-100 mb-6 rounded-circle border border-4 border-white h-20px w-20px ${
                  data?.status2 == 'active'
                    ? ' bg-success '
                    : data?.status2 == 'inactive'
                    ? 'bg-secondary'
                    : 'bg-danger'
                }`}
              ></div>
            </div>
          </div>

          <div className='flex-grow-1'>
            <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
              <div className='d-flex flex-column'>
                <div className='d-flex align-items-center mb-2'>
                  <span className='text-gray-800 fs-2 fw-bolder me-1'>{data?.name}</span>
                  {data?.status === 'verified' && (
                    <KTSVG
                      path='/media/icons/duotune/general/gen026.svg'
                      className='svg-icon-2 ms-1'
                    />
                  )}

                  {data?.status === 'unverified' && (
                    <KTSVG
                      path='/media/icons/duotune/general/gen026.svg'
                      className='svg-icon-2 ms-1 svg-icon-success'
                    />
                  )}
                </div>

                <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                  <a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                  >
                    <KTSVG
                      path='/media/icons/duotune/communication/com006.svg'
                      className='svg-icon-4 me-1'
                    />
                    {camelCaseToNormalCase(data?.role)}
                  </a>
                  <a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                  >
                    <KTSVG
                      path='/media/icons/duotune/general/gen018.svg'
                      className='svg-icon-4 me-1'
                    />
                    {data?.isoCode === 'au' && 'Melbourne, Australia'}
                  </a>
                  <a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary mb-2'
                  >
                    <KTSVG
                      path='/media/icons/duotune/communication/com011.svg'
                      className='svg-icon-4 me-1'
                    />
                    {data?.email}
                  </a>
                </div>
              </div>
            </div>

            <div className='d-flex flex-wrap flex-stack account-stack'>
              <div className='d-flex flex-column flex-grow-1 pe-8'>
                <div className='d-flex flex-wrap'>
                  <div className='border border-gray-300 border-solid rounded min-w-125px py-3 px-4 me-6 mb-3'>
                    <div className='d-flex align-items-center'>
                      <KTSVG
                        path='/media/mobile/mail-envelope.svg'
                        className='svg-icon-3 svg-icon-primary me-2'
                      />
                      {fetchCountMessageLoading ? (
                        <Spinner size='sm' />
                      ) : (
                        <div className='fs-2 fw-bolder'>{countMessage?.data || 0}</div>
                      )}
                    </div>

                    <div className='fw-bold fs-6 text-gray-400'>Message Sent</div>
                  </div>

                  <div className='border border-gray-300 border-solid rounded min-w-125px py-3 px-4 me-6 mb-3'>
                    <div className='d-flex align-items-center'>
                      <a
                        href='#'
                        className='svg-icon-1 me-2 fs-10 badge badge-light-success badge-square p-1'
                      >
                        SMS
                      </a>
                      <div className='fs-2 fw-bolder'>
                        {creditsData && creditsData.credits && creditsData?.credits?.sms
                          ? FixedTwoDecimal(creditsData.credits.sms)
                          : 0}
                      </div>
                    </div>

                    <div className='fw-bold fs-6 text-gray-400'>SMS Credits</div>
                  </div>

                  <div className='border border-gray-300 border-solid rounded min-w-125px py-3 px-4 me-6 mb-3'>
                    <div className='d-flex align-items-center'>
                      <a
                        href='#'
                        className='svg-icon-1 me-2 fs-10 badge badge-light-info badge-square p-1'
                      >
                        MMS
                      </a>
                      <div className='fs-2 fw-bolder'>
                        {creditsData && creditsData.credits && creditsData?.credits?.mms
                          ? FixedTwoDecimal(creditsData?.credits?.mms)
                          : 0}
                      </div>
                    </div>

                    <div className='fw-bold fs-6 text-gray-400'>MMS Credits</div>
                  </div>
                </div>
              </div>

              {/* {user !== 'superAdmin' && (
                <div className='d-flex align-items-center w-200px w-sm-300px flex-column mt-3'>
                  <div className='d-flex justify-content-between w-100 mt-auto mb-2'>
                    <span className='fw-bold fs-6 text-gray-400'>Profile Compleation</span>
                    <span className='fw-bolder fs-6'>90%</span>
                  </div>
                  <div className='h-5px mx-3 w-100 bg-light mb-3'>
                    <div
                      className='bg-success rounded h-5px'
                      role='progressbar'
                      style={{width: '50%'}}
                    ></div>
                  </div>
                </div>
              )} */}
            </div>
          </div>
        </div>

        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            {listItems}
          </ul>
        </div>
      </div>
    </div>
  )
}

export {AdminAccountHeader}
